import { render, staticRenderFns } from "./PresseAnzeige.vue?vue&type=template&id=3d0df573&scoped=true&"
import script from "./PresseAnzeige.vue?vue&type=script&lang=ts&"
export * from "./PresseAnzeige.vue?vue&type=script&lang=ts&"
import style0 from "./PresseAnzeige.vue?vue&type=style&index=0&id=3d0df573&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0df573",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VProgressLinear,VRow,VSimpleTable,VTooltip})
